import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import { DialogActionsTitle } from '../../../../components/styled/Dialog'
import { pulseSx } from '../../../../utils/AnimationsUtils'
import SelectChipIndicator from '../SelectChipIndicator'
import ResizableNotes, { getNotesPanelWidth } from './ResizableNotes'

const NOTES_MAX_HEIGHT = 250

const scrollAreaSx = { overflowY: 'auto', scrollbarGutter: 'stable' }

const mainIndicatorSx = {
    '& td, & td *, & input': { fontWeight: 'bold', fontSize: '1rem' },
}

const IndicatorDialogLayout = ({
    open = false,
    title = '',
    titleActions = [],
    notes = '',
    onChangeNotes = () => {},
    status = {},
    onRegister = () => {},
    hasChanges = false,
    footer,
    children,
}) => (
    <Dialog open={open} maxWidth='xl' fullWidth>
        <DialogActionsTitle title={title} actions={titleActions}/>
        <DialogContent sx={{ display: 'flex', flexDirection: 'column', height: '70vh', minHeight: 400, overflow: 'hidden' }}>
            <Box sx={{ flex: 1, minHeight: 0 }}>
                <ResizableNotes
                    panelTitle={i18n.notes}
                    panelContent={(
                        <Grid size={'grow'}>
                            <textarea
                                style={{ width: '100%', height: '100%', maxHeight: NOTES_MAX_HEIGHT, margin: 0, resize: 'none', border: '1px lightGrey solid', borderRadius: 5, padding: '4px 8px', backgroundColor: 'white' }}
                                value={notes}
                                onChange={e => onChangeNotes(e.target.value)}
                                placeholder={i18n.takeNotes}
                            />
                        </Grid>
                    )}
                >
                    <Box sx={{ height: '100%', ...scrollAreaSx }}>
                        {children}
                    </Box>
                </ResizableNotes>
            </Box>
            <Divider sx={{ my: 1 }}/>
            <Grid container wrap='nowrap' alignItems='center'>
                <Grid size={'grow'} sx={{ ...scrollAreaSx, ...mainIndicatorSx }}>
                    {footer}
                </Grid>
                <Grid container justifyContent='flex-end' width={getNotesPanelWidth()} minWidth={getNotesPanelWidth()}>
                    <SelectChipIndicator right indicatorStatus={status} readOnly/>
                </Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant='contained' disableElevation onClick={onRegister} sx={hasChanges ? pulseSx : {}}>
                {i18n.register}
            </Button>
        </DialogActions>
    </Dialog>
)

IndicatorDialogLayout.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.string,
    titleActions: PropTypes.arrayOf(PropTypes.shape({
        icon: PropTypes.string,
        tooltip: PropTypes.string,
        onClick: PropTypes.func,
        displayed: PropTypes.bool,
    })),
    notes: PropTypes.string,
    onChangeNotes: PropTypes.func,
    status: PropTypes.shape({
        name: PropTypes.string,
        color: PropTypes.string,
        bgColor: PropTypes.string,
    }),
    onRegister: PropTypes.func,
    hasChanges: PropTypes.bool,
    footer: PropTypes.element,
    children: PropTypes.element,
}

export default IndicatorDialogLayout
